module.exports = __webpack_public_path__ + "assets/img/qxy.3955c759.jpg";